import React from "react";
import { useMediaQuery } from "@mui/material";
import Avatar from "../../Assests/Images/avatar.svg";
import Devices from "../../Assests/Images/devices.svg";

function Section1() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <div
        style={{
          padding: isSmallScreen?"":"3rem",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "30px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <h1
          style={{
            fontFamily: "Font1",
            fontSize: isSmallScreen ? "32px" : "48px",
            fontWeight: 900,
            color: "#141c3a",
            marginBottom: isSmallScreen?"20px":"0px",
            letterSpacing: "2px",
            textShadow: isSmallScreen?"0px 0.5px, 0.5px 0px, 0.5px 0.5px":"0px 1px, 1px 0px, 1px 1px",
            textAlign: "center",
          }}
        >
          Full Stack Developer, Programmer & Collaborator
        </h1>
        <h2
          style={{
            fontFamily: "Font2",
            fontSize: isSmallScreen ? "18px" : "24px",
            fontWeight: 500,
            color: "#0a0a0a",
            textAlign: "center",
          }}
        >
          Passionate about every line of code I write and every user experience I
          enhance.
        </h2>
        <div style={{ margin: "60px" }}>
          <img alt="avatar" src={Avatar} style={{ width: isSmallScreen ? "100px" : "200px" }} />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <img alt="Device" src={Devices} style={{ width: isSmallScreen ? "100%" : "60%" }} />
      </div>
    </section>
  );
}

export default Section1;
